import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { CardServiceProvider } from '../../../providers/card-service/card-service';

@Component({
  selector: 'page-cube-stack-add',
  templateUrl: 'cube-stack-add.html',
})
export class CubeStackAddPage {

  titleCn: string
  titleDe: string
  tabInfo: string
  currentDate: string

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public viewCtrl: ViewController,
              public cardService: CardServiceProvider) {
  }

  ionViewDidLoad() {
    this.currentDate = new Date().toISOString()
  }

  dismiss(){
    this.viewCtrl.dismiss()
  }

  addCubeStack(){
    this.cardService.addCubeStack(this.titleCn, this.titleDe)
  }
}



// WEBPACK FOOTER //
// ./src/pages/library/cube-stack-add/cube-stack-add.ts